<template>
    <!-- 头部组件 -->
    <div :class="['jxw_nav', { 'jxw_nav--photography': $route.name === 'photograph', 'jxw_nav--account': $route.path.startsWith('/center') || ['photographyAppointmentPayment','photographyAppointmentConfirmation'].includes($route.name) }]">
        <el-row :gutter="10">
            <!-- logo -->
            <el-col :span="4" class="header-logo-column">
                <router-link to="/" class="logo">
                    <img :src="require('@/assets/logo.png')" alt="">
                </router-link>
            </el-col>
            <!-- nav -->
            <el-col :span="16" class="header-nav-column" style="text-align: center">
                <header-nav></header-nav>
            </el-col>
            <!-- search & login -->
            <el-col :span="4" class="header-account-column">
                <div class="jxw_nav_right">
                    <!-- 登录成功 -->
                    <div class="jxw_nav_is_login"
                        v-if="is_login">
                        <!-- 个人中心 -->
                        <router-link to="/center" class="header-user-link">
                            <img
                                :src="user_avatar"
                                :alt="user_nickname"
                                class="header-user-avatar"
                                @error="handleAvatarError">
                            <span class="header-user-nickname">{{user_nickname}}</span>
                        </router-link>
                        <!-- 注销 -->
                        <a href="javascript:;"
                            @click="handleLogout">
                            <span>退出</span>
                        </a>
                    </div>
                    <!-- 登录区域 -->
                    <el-button 
                        type="warning" 
                        round
                        @click="$router.push('/login')"
                        v-else>
                        <span>登录&nbsp;/&nbsp;注册</span>
                    </el-button>
                    <!-- <router-link 
                        to="/login" 
                        class="login_area"
                        v-else>
                        <span class="glyphicon glyphicon-user"></span>
                        <span class="login">登录&nbsp;/&nbsp;免费注册</span>
                    </router-link> -->
                </div>
            </el-col>
        </el-row>
    </div>
</template>

<script>
import { mapState, mapActions } from "vuex";
import defaultAvatar from "@/assets/images/avatar-default.png";
import { resolveProfileName } from "@/tool/profileView.cjs";

export default {
    data() {
        return {
            defaultAvatar,
            avatarLoadFailed: false,
        };
    },
    computed: {
        ...mapState({
            is_login: state => state.user.is_login,
            user_name: state => state.user.user_name,
            basic_data: state => state.user.basic_data || {},
        }),
        user_nickname() {
            return resolveProfileName(this.basic_data, this.user_name) || "用户";
        },
        user_avatar_source() {
            return this.basic_data.head || "";
        },
        user_avatar() {
            return this.avatarLoadFailed || !this.user_avatar_source
                ? this.defaultAvatar
                : this.user_avatar_source;
        },
    },
    watch: {
        user_avatar_source() {
            this.avatarLoadFailed = false;
        },
    },
    components: {
        headerNav: () => import("@/components/headerNav")
    },
    methods:{
        ...mapActions([
            "postLogout"
        ]),
        handleLogout(){
            this.postLogout().then((res) => {
                this.$message({
                    showClose: true,
                    message: res,
                    type: "success"
                })
                setTimeout(() => {
                    this.$router.replace("/login")
                },1000)
            }).catch(() => {})
        },
        handleAvatarError(){
            this.avatarLoadFailed = true;
        }
    },
}
</script>

<style scoped>
/* 导航栏 */
.jxw_nav{
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    background-color: #fff;
    z-index: 1000;
}
/* logo */
.logo{
    display: inline-block;
    width: 100%;
    height: 80px;
    /* padding: 10px 0; */
    text-align: center;
    background: #fff;
}
.logo>img{
    height: 100%;
}
/* 导航栏右侧 */
.jxw_nav_right{
    width: 100%;
    height: 80px;
    line-height: 80px;
    text-align: center;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
}
/* 登录区域 */
.jxw_nav_right>.login_area{
    display: inline-block;
    /* margin-left: 20px; */
}
/* 字体区域 */
.jxw_nav_right>.login_area>span{
    margin-right: 10px;
    color: #fff;
}
/* 登录成功样式 */
.jxw_nav_is_login,
.jxw_nav_is_login>a{
    display: inline-block;
    vertical-align: middle;
    color: #303133;
}
.jxw_nav_is_login>a:hover{
    color: #E6A23C;
}
.jxw_nav_is_login>a:first-child{
    display: inline-flex;
    align-items: center;
    width: auto;
    margin-right: 10px;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
}
.header-user-avatar{
    flex: none;
    width: 34px;
    height: 34px;
    margin-right: 8px;
    border-radius: 50%;
    object-fit: cover;
}
.header-user-nickname{
    max-width: 88px;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
}
.jxw_nav_is_login>a:last-child{
    font-weight: bold;
    color: #F56C6C
}
@media (max-width: 767px){
    .jxw_nav--photography>>>.el-row{
        display: grid;
        grid-template-columns: 1fr auto;
        grid-template-rows: 60px 44px;
        margin: 0 !important;
    }
    .jxw_nav--photography>>>.header-logo-column,
    .jxw_nav--photography>>>.header-nav-column,
    .jxw_nav--photography>>>.header-account-column{
        width: auto;
        padding: 0 !important;
    }
    .jxw_nav--photography .header-logo-column{ grid-column: 1; grid-row: 1; min-width: 0; }
    .jxw_nav--photography .header-nav-column{ grid-column: 1 / -1; grid-row: 2; min-width: 0; border-top: 1px solid #f0eff4; }
    .jxw_nav--photography .header-account-column{ grid-column: 2; grid-row: 1; }
    .jxw_nav--photography .logo{
        width: 132px;
        height: 60px;
        text-align: left;
    }
    .jxw_nav--photography .logo>img{
        max-width: 100%;
        object-fit: contain;
    }
    .jxw_nav--photography .jxw_nav_right{
        width: auto;
        height: 60px;
        padding-right: 12px;
        line-height: 60px;
    }
    .jxw_nav--photography .jxw_nav_right>>>.el-button{
        padding: 10px 14px;
    }
    .jxw_nav--photography .header-user-nickname{ max-width: 70px; }
    .jxw_nav--photography>>>.header-nav-wrapper{
        width: 100%;
        overflow-x: auto;
        scrollbar-width: none;
    }
    .jxw_nav--photography>>>.header-nav-wrapper::-webkit-scrollbar{ display: none; }
    .jxw_nav--photography>>>.header-nav{
        width: max-content;
        min-width: 100%;
        justify-content: flex-start;
    }
    .jxw_nav--photography>>>.header-nav>li{ flex: none; }
    .jxw_nav--photography>>>.header-nav-item{
        width: auto;
        height: 44px;
        padding: 0 14px;
        line-height: 44px;
        white-space: nowrap;
    }
}
@media (max-width: 767px){
    .jxw_nav--account>>>.el-row{
        display: grid;
        grid-template-columns: 1fr auto;
        grid-template-rows: 60px 44px;
        margin: 0 !important;
    }
    .jxw_nav--account>>>.header-logo-column,
    .jxw_nav--account>>>.header-nav-column,
    .jxw_nav--account>>>.header-account-column{
        width: auto;
        padding: 0 !important;
    }
    .jxw_nav--account .header-logo-column{ grid-column: 1; grid-row: 1; min-width: 0; }
    .jxw_nav--account .header-nav-column{ grid-column: 1 / -1; grid-row: 2; min-width: 0; border-top: 1px solid #f0eff4; }
    .jxw_nav--account .header-account-column{ grid-column: 2; grid-row: 1; }
    .jxw_nav--account .logo{
        width: 132px;
        height: 60px;
        text-align: left;
    }
    .jxw_nav--account .logo>img{
        max-width: 100%;
        object-fit: contain;
    }
    .jxw_nav--account .jxw_nav_right{
        width: auto;
        height: 60px;
        padding-right: 12px;
        line-height: 60px;
    }
    .jxw_nav--account .jxw_nav_right>>>.el-button{
        padding: 10px 14px;
    }
    .jxw_nav--account .header-user-nickname{ max-width: 70px; }
    .jxw_nav--account>>>.header-nav-wrapper{
        width: 100%;
        overflow-x: auto;
        scrollbar-width: none;
    }
    .jxw_nav--account>>>.header-nav-wrapper::-webkit-scrollbar{ display: none; }
    .jxw_nav--account>>>.header-nav{
        width: max-content;
        min-width: 100%;
        justify-content: flex-start;
    }
    .jxw_nav--account>>>.header-nav>li{ flex: none; }
    .jxw_nav--account>>>.header-nav-item{
        width: auto;
        height: 44px;
        padding: 0 14px;
        line-height: 44px;
        white-space: nowrap;
    }
}
</style>
